<template>
    <div>
        <v-header  :is-seft="0" @touchmove.prevent ></v-header>
        <v-goods :is-seft="0"  :is-seft-pay="1"></v-goods>
    </div>
</template>

<script>
    import header from '../components/Header';
    import goods from '../components/Goods';

    export default {
        inject: ['reload'],
        data() {
            return {
                seller: {},
                tableOrderInfo: {},
            }
        },
        created() {
        },
        methods: {
      
            getPath() {
                //if (this.$route.path == '/buffet') {
                //    this.getRestaurantInfo();
                //}
            }
        },
        watch: {
            '$route': 'getPath'
        },
        components: {
            'v-header': header,
            'v-goods': goods
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/GoodsMain.vue